const MediaAssets = {
  undo: require('./undo.png'),
  redo: require('./redo.png'),
  print: require('./print.png'),
  spellcheck: require('./spellcheck.png'),
  paint: require('./imagesearch_roller.png'),
  bold: require('./format_bold.png'),
  italic: require('./format_italic.png'),
  underline: require('./format_underlined.png'),
  textColor: require('./text_format.png'),
  highlightColor: require('./format_ink_highlighter.png'),
  link: require('./link.png'),
  addComment: require('./add_comment.png'),
  image: require('./image.png'),
  leftTextAlign: require('./format_align_left.png'),
  lineSpacing: require('./format_line_spacing.png'),
  checklist: require('./checklist.png'),
  bullets: require('./format_list_bulleted.png'),
  numberedList: require('./format_list_numbered.png'),
  decreaseIndent: require('./format_indent_decrease.png'),
  increaseIndent: require('./format_indent_increase.png'),
  clearFormatting: require('./format_clear.png'),
  googleDocs: require('./google-docs.png'),
  star: require('./star.png'),
  moveFolders: require('./drive_file_move.png'),
  cloudDone: require('./cloud_done.png'),
  calendar: require('./google-calendar.png'),
  keep: require('./keeps.png'),
  tasks: require('./tasks.png'),
  contacts: require('./phone-book.png'),
  maps: require('./maps.png'),
  history: require('./history.png'),
  comments: require('./comment.png'),
  videocam: require('./videocam.png'),
  lock: require('./lock.png'),
  accounts: require('./account.png')
}
export default MediaAssets;